import React, { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import storage from "utils/storage";

export function TerminateSessionButton() {
  const [shouldShow, setShouldShow] = useState(false);
  const backup = storage.getOriginalToken();
  const sessionStore = storage.getSessionImpersonationToken();

  useEffect(() => {
    const mainToken = storage.getToken();
    const originalToken = storage.getOriginalToken();

    if (mainToken && originalToken) {
      setShouldShow(true);
    } else {
      setShouldShow(false);
    }
  }, []);

  const handleTerminate = () => {
    // const backup = storage.getOriginalToken();

    if (sessionStore) {
      // storage.setToken(backup);
      storage.clearOriginalToken();
      storage.clearSessionImpersonationToken();
      showNotification({
        title: "Session Restored",
        message: "SuperAdmin session has been restored",
        color: "blue",
      });

      window.location.href = "/dashboard";
    } else {
      showNotification({
        title: "No Impersonation",
        message: "No Backup token found to restore session",
        color: "red",
      });
    }
  };

  if (!sessionStore) return null;

  return (
    <Button variant="filled" radius="md" size="sm" onClick={handleTerminate}>
      Terminate Session
    </Button>
  );
}
